import ElementContentHeaderCheckout from '@/components/sections/builder/elements/header/header-checkout/content';
import ElementSettingHeaderCheckout from '@/components/sections/builder/elements/header/header-checkout/setting';
import { HeaderCheckoutElementDataType } from '@/components/sections/builder/elements/header/header-checkout/type';
import { BetweenHorizonalStart } from 'lucide-react';

const defaultData: HeaderCheckoutElementDataType = {
  name: 'Header',
  stickyHeader: 'always',
  logoPosition: 'left',
  mobileLogoPosition: 'center',
  isShowSeparator: true,
  isShowCart: true,
  padding: {
    top: 24,
    bottom: 24,
    left: 24,
    right: 24,
  },
};

export const ElementPreviewIcon = BetweenHorizonalStart;

const HeaderCheckout = {
  type: 'header_checkout',
  group: 'header_checkout',
  defaultData,
  Element: ElementContentHeaderCheckout,
  Setting: ElementSettingHeaderCheckout,
  PreviewIcon: ElementPreviewIcon,
  maxEntries: 1,
  isImmutable: true,
};

export default HeaderCheckout;
